<template lang="html">


  <div class="wrapper margin-menu">

    <section class="intro column-center -fundacion">
      <h2>La Fundación</h2>
      <h1>Misión</h1>
    </section>

    <section class="breadcrumb">
      <nav class="container row-end">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.lafundacion')">La Fundación</router-link>
        <router-link :to="$t('enlaces.mision')">Misión</router-link>
      </nav>
    </section>

    <main>

      <section class="container">

        <h2 class="title-intro">
          Objetivos y <strong>principios</strong>
        </h2>

        <p class="texto-intro">
          <strong>La misión de la Fudación es dar continuidad y fomentar los principios que fueron transmitidos por Don Tomás Pascual y Dña Pilar Gómez-Cuétara,</strong> quienes siempre han creido que
          el cultivo de los valores era la clave para construir una sociedad más saludable y honesta.
        </p>

      </section>


      <section class="mision-box">
        <div class="container column-center">
          <h2 class="big-title left">Misión</h2>
          <article class="mision-el row-start">
            <div class="texto">
              <p><strong>A través de nuestros proyectos ponemos el foco en los valores, entendidos como el hecho diferencial que dan lugar a diferentes comportamientos, que a la vez conforman las culturas y
                  formas de estar en el mundo.</strong> En el entorno global en que vivimos, creemos que es posible crear un espacio cuya identidad esté basada en la diversidad, contando con todas las
                aportaciones y enriquecido por ellas.</p>
            </div>
            <div class="imagen">
              <img src="/static/img/mision-0.svg">
            </div>
          </article>

          <article class="mision-el row-end">
            <div class="imagen">
              <img src="/static/img/mision-1.svg">
            </div>
            <div class="texto">
              <p><strong>Desde esta filosofía investigamos sobre los fenómenos sociales que configuran el entorno actual</strong> (diferencias generacionales, igualdad, inmigración, discapacidad,
                etc.), y la forma en que se complementan los valores emergentes con las expectativas del mundo laboral. <strong>Buscamos soluciones para crear sintonía y espacios de convivencia
                  productiva que permitan la integración y satisfacción de las necesidades de todos.</strong></p>
            </div>
          </article>

          <article class="mision-el row-start">
            <div class="texto">
              <p><strong>Basándonos en los resultados de las investigaciones llevadas a cabo, en colaboración con diferentes entidades</strong> (Universidades, Fundaciones, Organismos públicos y
                privados, etc.), <strong>divulgamos e impartimos cursos y seminarios a diferentes colectivos</strong> (jóvenes, niños, personas en proceso de integración en el mundo laboral, personas
                con problemas de inserción social, etc.), que son los beneficiarios directos de nuestras actividades.</p>
            </div>
            <div class="imagen">
              <img src="/static/img/mision-2.svg">
            </div>
          </article>

          


        </div>
      </section>


      <section class="valores-box">
        <div class="container row-between ais">
          <h2 class="big-title">Valores</h2>
          <div class="valores-list">
            <h2 :active="valor.visible" @click="setvalor(key)" v-for="(valor,key) in valores">{{valor.titulo}}</h2>
          </div>

          <div class="valores-text">
            <template v-for="valor in valores">
              <h2>{{valor.titulo}}</h2>
              <p v-show="valor.visible">{{valor.texto}}</p>
            </template>
          </div>

        </div>
      </section>


      <section class="actividades-box">
        <div class="container row-between ais">
          <h2 class="big-title">Actividades</h2>

          <div class="actividad-el">
            <div class="contenedor-imagen column-center">
              <img src="/static/img/actividad-0.svg" alt="imagen actividad">
            </div>
            <p>Generar y difundir actividades de investigación, estudio y análisis en los campos de la alimentación, la nutrición, la salud y los hábitos correctos de vida.</p>
          </div>

          <div class="actividad-el">
            <div class="contenedor-imagen column-center">
              <img src="/static/img/actividad-1.svg" alt="imagen actividad">
            </div>
            <p> Investigar sobre valores humanos y pedagogía formativa para transmitirlos a la sociedad en general y al mundo de la empresa en concreto, mediante programas de formación y divulgación que permitan la integración social y laboral. </p>
          </div>

          <div class="actividad-el">
            <div class="contenedor-imagen column-center">
              <img src="/static/img/actividad-2.svg" alt="imagen actividad">
            </div>
            <p>Participar activamente en iniciativas nacionales e internacionales que contribuyan al desarrollo de ecosistemas de emprendimiento.</p>
          </div>

          <div class="actividad-el">
            <div class="contenedor-imagen column-center">
              <img src="/static/img/actividad-3.svg" alt="imagen actividad">
            </div>
            <p> Realizar proyectos o actividades sociales, a nivel nacional o de cooperación internacional, que promuevan el desarrollo social, educativo, económico y cultural de la población, comenzando prioritariamente en facilitar el acceso a agua potable a los más desfavorecidos.​​</p>
          </div>

        </div>
      </section>





    </main>

  </div>

</template>

<script lang="js">
  
  
  export default {
    name: 'mision',
    data(){
      return{
        valores : [
          {
            "titulo" : "Integridad",
            "texto" : "Nos comprometemos a ser honestos, congruentes, consecuentes y responsables en todas nuestras áreas de actuación y todas nuestras relaciones con los grupos de interés.",
            "visible" : true
          },
          {
            "titulo" : "Cercanía",
            "texto" : "Nos vinculamos con los consumidores, clientes, empleados, accionistas, proveedores y sociedad en general, desde la igualdad, la empatía, el respeto mutuo, la confianza y la humildad.",
            "visible" : false
          },
          {
            "titulo" : "Pasión",
            "texto" : "Creemos en la cultura de la responsabilidad y estamos convencidos de que el éxito se consigue gracias a la motivación, el compromiso, la ilusión y el entusiasmo que demostramos todas las personas de la organización.",
            "visible" : false
          },
          {
            "titulo" : "Calidad",
            "texto" : "Buscamos la excelencia, y crear un valor añadido que nos diferencie, a través del talento y el esfuerzo que todos ponemos para la mejora diaria de nuestros productos, servicios y gestión.",
            "visible" : false
          },
          {
            "titulo" : "Innovación",
            "texto" : "Soñamos con un futuro mejor, y por este motivo ponemos todo el esfuerzo y los recursos necesarios para aportar nuevas y eficientes soluciones a las necesidades actuales y futuras de nuestros grupos de interés.",
            "visible" : false
          }
        ]
      }
    },
    methods : {
      setvalor(pos){
        this.valores.forEach(v => v.visible = false);
        this.valores[pos].visible = true;
      }
    }
  }
    
  </script>
<style lang="scss">
  
  </style>


// WEBPACK FOOTER //
// src/components/views/mision.vue